import {
    FilterBar,
    FilterBarDropdown,
    FilterBarSearch,
    Segment,
    SegmentContent,
    SegmentHeader,
    Toggle,
} from '@/platform/ui';
import { useMemo, useState } from 'react';

const DISPLAY_OPTIONS = [
    { id: 'all', name: 'Alle' },
    { id: 'active', name: 'Actief' },
    { id: 'inactive', name: 'Inactief' },
];

const isAssigned = (assigned, id) =>
    (assigned || []).some(current => String(current) === String(id));

const PermissionGrid = ({ permissions = [], assigned = [], onToggle }) => {
    const [search, setSearch] = useState('');
    const [display, setDisplay] = useState('all');

    const visible = useMemo(() => {
        const term = search.trim().toLowerCase();

        return permissions.filter(permission => {
            const matchesTerm =
                !term ||
                `${permission.description || ''} ${permission.name || ''}`
                    .toLowerCase()
                    .includes(term);

            if (!matchesTerm) {
                return false;
            }

            if (display === 'active') {
                return isAssigned(assigned, permission.id);
            }

            if (display === 'inactive') {
                return !isAssigned(assigned, permission.id);
            }

            return true;
        });
    }, [permissions, assigned, search, display]);

    return (
        <Segment>
            <SegmentHeader
                header={`Permissies (${assigned?.length || 0}/${permissions.length})`}
            />
            <SegmentContent>
                <FilterBar>
                    <FilterBarDropdown
                        label={
                            DISPLAY_OPTIONS.find(
                                option => option.id === display
                            )?.name
                        }
                        options={DISPLAY_OPTIONS}
                        value={display}
                        onChange={setDisplay}
                    />
                    <FilterBarSearch
                        value={search}
                        placeholder='Zoeken in permissies...'
                        onChange={value => setSearch(value)}
                    />
                </FilterBar>

                {visible.length === 0 ? (
                    <p className='py-8 text-center text-sm text-gray-500'>
                        Geen permissies gevonden.
                    </p>
                ) : (
                    <div className='grid gap-4 sm:grid-cols-2 lg:grid-cols-3'>
                        {visible.map(permission => (
                            <div
                                key={permission.id}
                                className='flex items-center justify-between gap-4 rounded-lg border border-gray-200 p-4'
                            >
                                <div className='min-w-0'>
                                    <p className='text-sm font-semibold text-gray-900'>
                                        {permission.description}
                                    </p>
                                    <p className='mt-0.5 font-mono text-xs break-all text-gray-500'>
                                        {permission.name}
                                    </p>
                                </div>
                                <Toggle
                                    checked={isAssigned(
                                        assigned,
                                        permission.id
                                    )}
                                    onChange={() => onToggle(permission.id)}
                                    aria-label={
                                        permission.description ||
                                        permission.name
                                    }
                                />
                            </div>
                        ))}
                    </div>
                )}
            </SegmentContent>
        </Segment>
    );
};

export default PermissionGrid;
